<app-dashboard-stats-card [title]="'Owned'" subtitle="Packages owned by your provider." [count]="getPackageCount()"
                          [routerLink]="'/my-packages'" [queryParams]="{ open: false, open_o: 'is' }" />
